<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">車輛進出異常狀況</div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              統計篩選條件
            </div>
            <div class="row h6">
              <div class="col-12 mt-2">
                <form class="form-inline">
                  <label class="my-1 mr-2" for="inlineFormCustomSelectPref"
                    >選擇風景區</label
                  >
                  <select
                    class="custom-select my-1 mr-sm-2"
                    id="inlineFormCustomSelectPref"
                  >
                    <option value="1">三仙台</option>
                  </select>
                  <label
                    class="my-1 mr-2 text-right"
                    for="inlineFormCustomSelectPref"
                    >選擇起日</label
                  >
                  <input
                    type="date"
                    class="form-control my-1 mr-sm-2"
                    id="customControlInline"
                    value="2022-02-01"
                  />
                  <label
                    class="my-1 mr-2 text-right"
                    for="inlineFormCustomSelectPref"
                    >選擇訖日</label
                  >
                  <input
                    type="date"
                    class="form-control my-1 mr-sm-2"
                    id="customControlInline"
                    value="2022-02-03"
                  />

                  <button type="submit" class="btn btn-primary my-1">
                    送出查詢
                  </button>
                  <button type="submit" class="btn btn-primary my-1 ml-2">
                    匯出Excel
                  </button>
                  <button
                    type="button"
                    class="btn btn-success my-1 ml-2"
                    data-toggle="modal"
                    data-target="#model2"
                  >
                    例外車輛清單
                  </button>
                </form>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="30%">進入時間</th>
                      <th scope="col" width="30%">車輛車號</th>
                      <th scope="col" width="30%">異常時間</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in dashbords"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ key + 1 }}</td>
                      <td>{{ item.date }}</td>
                      <td>
                        {{ item.type }}
                        <button
                          class="btn btn-warning my-1 ml-2"
                          data-toggle="modal"
                          data-target="#exampleModalCenter"
                        >
                          加入例外清單
                        </button>
                      </td>
                      <td>{{ item.note }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 加入例外清單Modal -->
    <div class="modal fade" id="exampleModalCenter">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h5">車號：MD5-5566，加入例外車輛清單</div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group h6">
              <label for="exampleFormControlTextarea1">請填入原因(必填)</label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              取消
            </button>
            <button type="button" class="btn btn-primary">儲存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <!-- 例外清單Modal -->
    <div class="modal fade" id="model2">
      <div class="modal-dialog modal-dialog-centered  modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h5">例外車輛清單</div>
          </div>
          <div class="modal-body">
            <table :class="tableStyle">
              <tr>
                <td>車號</td>
                <td>加入時間</td>
                <td>加入原因</td>
                <td>填寫帳號</td>
              </tr>
              <tr>
                <td>ACC-6666</td>
                <td>2022/02/01 10:00</td>
                <td>員工車號</td>
                <td>00001</td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              取消
            </button>
            <button type="button" class="btn btn-primary">儲存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      dashbords: [
        {
          date: "2022/02/01 09:00",
          type: "MD5-5566",
          note: "4天又12小時25分鐘20秒",
        },
        {
          date: "2022/02/02 15:00",
          type: "ABC -1111",
          note: "3天又12小時25分鐘20秒",
        },
      ],
    };
  },
  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
    selectStreaming: function (item, dashboard) {
      this.$refs.streamingModal.openModal();
      this.selectItem = item;
      this.selectDashoard = dashboard;
    },
  },
};
</script>